export const errorsCode: any = {
	CodeMismatchException: 'El código de verificación proporcionado no es válido',
	UserNotFoundException: 'El usuario no existe',
	NotAuthorizedException: 'Usuario incorrecto o código caducado',
	LimitExceededException:
		'Se excedió el límite de reintentos, vuelva a intentarlo más tarde',
	InvalidParameterException: 'Hubo un error al intentar realizar esta acción.',
	TooManyFailedAttemptsException:
		'Has superado el número de intentos permitidos',
	ExpiredCodeException: 'El código de verificación ha expirado',
	UnexpectedLambdaException: 'Hubo un error al intentar realizar esta acción.',
	ResourceNotFoundException:
		'Hubo un error al intentar procesar esta operación. Inténtalo de nuevo más tarde.',
	InvalidPasswordException:
		'Su contraseña debe contener al menos 8 caracteres, una letra, un número y un carácter especial',
	UserLambdaValidationException:
		'Hubo un error al intentar procesar esta operación. Póngase en contacto con el equipo de soporte.',
	UsernameExistsException:
		'Ya existe una cuenta con el correo electrónico proporcionado.',
	UserNotConfirmedException:
		'La cuenta no ha sido confirmada, por favor verifique su correo electrónico.',
};
